import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Dialog from '@/modules/common/components/Dialog';
import Spinner from '@/modules/common/components/Spinner';
import ErrorFetch from '@/modules/common/components/ErrorFetch';
import { withFetch } from '~/hocs/fetch';

let abortController;

const DialogView = (props) => {
    const [loading, setLoading] = useState(false);
    const [note, setNote] = useState(null);

    const fetch = () => {
        setLoading(true);
        props.fetch.get(`/api/notes/${props.selectedNote.id}/`, abortController)
            .then(({ok, data}) => {
                if (ok) {
                    setNote(data);
                }
                setLoading(false);
            })
            .catch((error) => {
                if (error.name !== 'AbortError') {
                    setLoading(false);
                }
            })
            .finally(() => {
                abortController = null;
            });
    };

    useEffect(() => {
        if (props.open) {
            abortController = new AbortController();
            fetch();
        }
        return () => {
            if (abortController) {
                abortController.abort();
            }
        };
    }, [props.open]);

    const handleClose = () => {
        props.setOpen(false);
        props.setSelectedNote(null);
    };

    const handleExited = () => {
        setNote(null);
    };

    return (
        <Dialog id="notes-dialog-view" title="Просмотр заметки" open={props.open} onClose={handleClose}
                onExited={handleExited}
        >
            {(!loading)
                ? <>
                    {(note)
                        ? <div dangerouslySetInnerHTML={{__html: note.note}}/>
                        : <ErrorFetch onClick={() => fetch()}/>
                    }
                </>
                : <Spinner/>
            }
        </Dialog>
    );
};


DialogView.propTypes = {
    selectedNote: PropTypes.object,
    setSelectedNote: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    setOpen: PropTypes.func.isRequired,
};

let Component = DialogView;
Component = withFetch(Component);

export default Component;
